<script setup lang="ts">
import { api } from '@/api'
import { ElMessage } from 'element-plus'
import { ref } from 'vue'
import { convertToUTC } from '@/utils/date'

const getRandomCode = () => Math.floor(1000 + Math.random() * 9000)
const date = ref<Date>()
const code = ref<number>(getRandomCode())
const language = ref<string>('ru')

const emit = defineEmits(['created'])
const create = async () => {
  if (!date.value) {
    return
  }

  await api.webinars.create({
    date: convertToUTC(date.value),
    code: Number(code.value),
    language: language.value,
  })
  ElMessage.success('Webinar created')
  date.value = undefined
  code.value = getRandomCode()
  emit('created')
}
</script>

<template>
  <h3>Create Webinar</h3>
  <el-card style="width: 400px; margin-bottom: 20px">
    <el-form>
      <el-form-item label="Date">
        <el-date-picker
          v-model="date"
          type="datetime"
          time-format="HH:mm"
          placeholder="Время GMT0"
        />
      </el-form-item>
      <el-form-item label="Code">
        <el-input v-model="code" type="number" />
      </el-form-item>
      <el-form-item label="Language">
        <el-radio-group v-model="language">
          <el-radio-button label="Русский" value="ru" />
          <el-radio-button label="English" value="en" />
          <el-radio-button label="Українська" value="uk" />
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="create">Create</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>
